export const RECEIVE_VIDEOS = "RECEIVE_VIDEOS";
export const RECEIVE_APPLETV_VIDEOS = "RECEIVE_APPLETV_VIDEOS";
export const DISPLAY_DROPDOWN = "DISPLAY_DROPDOWN";
export const REMOVE_DROPDOWN = "REMOVE_DROPDOWN";
export const NEW_ACTIVE_VIDEO = "NEW_ACTIVE_VIDEO";
export const REMOVE_ACTIVE_VIDEO = "REMOVE_ACTIVE_VIDEO";
export const PREVIOUS_SELECTED_ASSET = "PREVIOUS_SELECTED_ASSET";
export const NEW_SELECTED_ASSET = "NEW_SELECTED_ASSET";
export const NEW_SELECTED_ASSET_ROW = "NEW_SELECTED_ASSET_ROW";
export const SET_CURATED_ROW = "SET_CURATED_ROW";
export const SET_TARGET_ASSET = "SET_TARGET_ASSET";
export const UPDATE_WATCHLIST = "UPDATE_WATCHLIST";
export const TOGGLE_VOLUME = "TOGGLE_VOLUME";
export const SET_SVOD_ENVIRONMENT = "SET_SVOD_ENVIRONMENT";
export const SET_PROFILE_PICTURE_NUMBER = "SET_PROFILE_PICTURE_NUMBER";
export const TOGGLE_SURVEY_ACTIVE = "TOGGLE_SURVEY_ACTIVE";
export const UPDATE_VIDEO_PROGRESS = "UPDATE_VIDEO_PROGRESS";
export const CLOSED_TARGET_ASSET = "CLOSED_TARGET_ASSET";

export const receiveVideos = (rows) => ({
	type: RECEIVE_VIDEOS,
	rows
});

export const setAppleTVVideos = (payload) => ({
	type: RECEIVE_APPLETV_VIDEOS,
	appleTVVideos: payload
});

export const setEnvironment = (environment) => ({
	type: SET_SVOD_ENVIRONMENT,
	environment
});

export const saveProfilePictureNumber = (profilePictureNumber) => ({
	type: SET_PROFILE_PICTURE_NUMBER,
	profilePictureNumber
});

export const displayDropdown = (payload) => ({
	type: DISPLAY_DROPDOWN,
	dropdown: payload
});

export const removeDropdown = () => ({
	type: REMOVE_DROPDOWN,
	dropdown: {}
});

export const newActiveVideo = (payload) => ({
	type: NEW_ACTIVE_VIDEO,
	activeVideo: payload
});

export const removeActiveVideo = () => ({
	type: REMOVE_ACTIVE_VIDEO,
	activeVideo: {}
});

export const setPreviousSelectedAsset = (selectedAsset) => ({
	type: PREVIOUS_SELECTED_ASSET,
	selectedAsset
});

export const setSelectedAsset = (selectedAsset) => ({
	type: NEW_SELECTED_ASSET,
	selectedAsset
});

export const setSelectedAssetRow = (selectedAssetRow) => ({
	type: NEW_SELECTED_ASSET_ROW,
	selectedAssetRow
});

export const setCuratedRow = (curatedRow) => ({
	type: SET_CURATED_ROW,
	curatedRow
});

export const setTargetAsset = (targetAssetId) => ({
	type: SET_TARGET_ASSET,
	targetAssetId
});

export const updateWatchlist = (newWatchlist) => ({
	type: UPDATE_WATCHLIST,
	newWatchlist
});

export const toggleVolume = (volume) => ({
	type: TOGGLE_VOLUME,
	volume
});

export const toggleActiveSurvey = (isSurveyActive) => ({
	type: TOGGLE_SURVEY_ACTIVE,
	isSurveyActive
});

export const updateVideoProgress = (newVideoProgressList) => ({
	type: UPDATE_VIDEO_PROGRESS,
	newVideoProgressList
});

export const closeTargetAsset = () => ({
	type: CLOSED_TARGET_ASSET
});


// WEBPACK FOOTER //
// ./src/redux/actions/SVOD.js